import { INotificationState } from "./interface";

export default <INotificationState> {
	toasts: []
}